import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=1c4e9726"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=1c4e9726&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4e9726')) {
      api.createRecord('1c4e9726', component.options)
    } else {
      api.reload('1c4e9726', component.options)
    }
    module.hot.accept("./mainLayout.vue?vue&type=template&id=1c4e9726", function () {
      api.rerender('1c4e9726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Wrappers/mainLayout.vue"
export default component.exports